const setLocalData = (key: string, dados: any) => {
  localStorage.setItem(key, JSON.stringify(dados));
};

const getLocalData = (key: string) => {
  const storedData = localStorage.getItem(key);
  try {
    return storedData ? JSON.parse(storedData) : null;
  } catch (error) {
    console.error("Erro ao parsear dado do localStorage:", key, storedData, error);
    localStorage.removeItem(key);
    return null;
  }
};

const removeLocalData = (key: string) => {
  localStorage.removeItem(key);
};

export { setLocalData as setSessionData, getLocalData as getSessionData, removeLocalData as removeSessionData };
